// eslint-disable-next-line no-unused-vars
export const rootImagePath = `${process.env.PUBLIC_URL}`;

//Images
export const coverImage = `${rootImagePath}/images/mystanleymartin_cover.jpg`;

//Regex
export const regAlphaNumb = /[^a-zA-Z0-9_]/g;